// extracted by mini-css-extract-plugin
export default {"textData":"i6sNAt0","showMoreButton":"H_Dcft2"};